import ThemeConfig from '../../themes/theme-config';
import ParsedConfig from '../parse/types/parsed-config';
import Config, { CardContent, CardContentConfig, FilterConfig, Filters } from '../types/config';

const mergeConfig = (defaultConfig: Config, themeConfig: ThemeConfig, parsedConfig: ParsedConfig): Config => ({
  data: {
    ...defaultConfig.data,
    // ...stripUndefined(window.dvinciJobWidgetConfig?.data),
    ...stripUndefined(themeConfig.data),
    ...stripUndefined(parsedConfig.data),
  },
  ui: {
    ...defaultConfig.ui,
    // ...stripUndefined(window.dvinciJobWidgetConfig?.ui),
    ...stripUndefined(themeConfig.ui),
    ...stripUndefined(parsedConfig.ui),
  },
  cardContent: mergeCardContent(
    defaultConfig.cardContent,
    // { ...window.dvinciJobWidgetConfig?.cardContent },
    { ...themeConfig.cardContent },
    { ...parsedConfig.cardContent },
  ),
  styles: {
    ...defaultConfig.styles,
    // ...stripUndefined(window.dvinciJobWidgetConfig?.styles),
    ...stripUndefined(themeConfig.styles),
    ...stripUndefined(parsedConfig.styles),
    labelStyle: {
      ...defaultConfig.styles?.labelStyle,
      // ...stripUndefined(window.dvinciJobWidgetConfig?.styles?.labelStyle),
      ...stripUndefined(themeConfig.styles?.labelStyle),
      ...stripUndefined(parsedConfig.styles?.labelStyle),
    },
    headlineStyle: {
      ...defaultConfig.styles?.headlineStyle,
      // ...stripUndefined(window.dvinciJobWidgetConfig?.styles?.headlineStyle),
      ...stripUndefined(themeConfig.styles?.headlineStyle),
      ...stripUndefined(parsedConfig.styles?.headlineStyle),
    },
    inputStyle: {
      ...defaultConfig.styles?.inputStyle,
      // ...stripUndefined(window.dvinciJobWidgetConfig?.styles?.inputStyle),
      ...stripUndefined(themeConfig.styles?.inputStyle),
      ...stripUndefined(parsedConfig.styles?.inputStyle),
    },
    cardStyle: {
      ...defaultConfig.styles?.cardStyle,
      // ...stripUndefined(window.dvinciJobWidgetConfig?.styles?.cardStyle),
      ...stripUndefined(themeConfig.styles?.cardStyle),
      ...stripUndefined(parsedConfig.styles?.cardStyle),
    },
  },
  filters: mergeFilters(defaultConfig.filters, { ...themeConfig.filters }, { ...parsedConfig.filters }),
  i18n: {
    messages: {
      // ...stripUndefined(window.dvinciJobWidgetConfig?.i18n?.messages),
      ...themeConfig.i18n?.messages,
    },
  },
  api: {
    maps: {
      ...defaultConfig.api.maps,
      // ...stripUndefined(window.dvinciJobWidgetConfig?.api?.maps),
      ...stripUndefined(themeConfig.api?.maps),
      ...stripUndefined(parsedConfig.api.maps),
    },
  },
});

const stripUndefined = <T>(object?: T): any => {
  if (typeof object === 'undefined') return {};

  const filtered: any = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(object)) {
    if (typeof value !== 'undefined') filtered[key] = value;
  }
  return filtered;
};

type FilterConfigRecords = Record<keyof Filters<any>, FilterConfig>;

type CardContentConfigRecords = Record<keyof CardContent<any>, CardContentConfig>;

interface Map<T> {
  [key: string]: T | undefined;
}

const mergeFilters = (
  defaultFilters: FilterConfigRecords,
  themeFilters: Map<Partial<FilterConfig>>,
  parsedFilters: Map<Partial<FilterConfig>>,
): Filters<FilterConfig> => {
  const filterConfigs: { [key: string]: FilterConfig } = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const [name, fallback] of Object.entries(defaultFilters)) {
    filterConfigs[name] = {
      enabled: firstOf(parsedFilters[name]?.enabled, themeFilters[name]?.enabled, fallback.enabled)!,
      hidden: firstOf(parsedFilters[name]?.hidden, themeFilters[name]?.hidden, fallback.hidden)!,
      selected: firstOf(parsedFilters[name]?.selected, themeFilters[name]?.selected, fallback.selected)!,
      allowed: firstOf(parsedFilters[name]?.allowed, themeFilters[name]?.allowed, fallback.allowed)!,
      order: firstOf(parsedFilters[name]?.order, themeFilters[name]?.order, fallback.order)!,
      label: firstOf(parsedFilters[name]?.label, themeFilters[name]?.label, fallback.label)!,
    };
  }

  return filterConfigs as FilterConfigRecords;
};

const mergeCardContent = (
  defaultCardContent: CardContentConfigRecords,
  // appoCardConfig: Map<Partial<CardContentConfig>>,
  themeCardContent: Map<Partial<CardContentConfig>>,
  parsedCardContent: Map<Partial<CardContentConfig>>,
): CardContent<CardContentConfig> => {
  const cardContentConfigs: { [key: string]: CardContentConfig } = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const [name, fallback] of Object.entries(defaultCardContent)) {
    cardContentConfigs[name] = {
      enabled: firstOf(
        parsedCardContent[name]?.enabled,
        themeCardContent[name]?.enabled,
        // appoCardConfig[name]?.enabled,
        fallback.enabled,
      )!,
      order: firstOf(
        parsedCardContent[name]?.order,
        themeCardContent[name]?.order,
        // appoCardConfig[name]?.order,
        fallback.order,
      )!,
    };
  }

  return cardContentConfigs as CardContentConfigRecords;
};

const firstOf = <T>(...values: T[]): T => {
  return values.find((it) => typeof it !== 'undefined')!;
};

export default mergeConfig;
